import "./textInput.scss";

export default function TextInput({
  placeholder,
  label,
  suggestions = [],
  onChange,
  clickOnSuggestion,
  val,
  status,
  onSpace,
  onScape,
  finalResult,
  validation,
  direction,
}) {
  function handleChange(e) {
    if (validation === "number") {
      var pattern = /^[0-9]+$/;
      if (pattern.test(e.target.value) || e.target.value === "") {
        onChange(e.target.value);
      }
    } else if (validation === "float") {
      // pattern = /^[0-9.]+$/;
      pattern = /^[0-9.-]+$/;
      if (pattern.test(e.target.value) || e.target.value === "") {
        onChange(e.target.value);
      }
    } else if (validation === "english") {
      pattern = /^[A-Za-z0-9]+$/;
      if (pattern.test(e.target.value) || e.target.value === "") {
        onChange(e.target.value);
      }
    } else if (validation === "amount") {
      const faToEnDigits = (str) =>
        String(str)
          .replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d))
          .replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d));

      // 1) حذف جداکننده‌ها  2) تبدیل اعداد فارسی/عربی به انگلیسی
      let raw = faToEnDigits(e.target.value).replace(/[٬,]/g, "");

      // فقط عدد + بدون صفر اول (0123 ممنوع)
      const pattern = /^(0|[1-9][0-9]*)$/;

      if (raw === "") {
        onChange("");
        return;
      }

      if (pattern.test(raw)) {
        // نمایش با جداکننده فارسی (و اعداد فارسی)
        const formatted = new Intl.NumberFormat("fa-IR").format(Number(raw));
        onChange(formatted);
      }
    } else {
      onChange(e.target.value);
    }
  }
  function handleKeyup(e) {
    if (e.code === "Space" && onSpace) {
      onChange(onSpace);
    } else if (e.code === "Escape" && onScape) {
      onChange(onScape);
    } else {
      onChange(e.target.value);
    }
  }
  return (
    <div className="textInput">
      <label>{label}:</label>
      <input
        className={finalResult}
        type="text"
        placeholder={placeholder}
        onChange={(e) => handleChange(e)}
        value={val}
        disabled={status}
        onKeyUp={(e) => handleKeyup(e)}
        style={{direction: direction}}
      />
      {suggestions.length > 0 && (
        <div className="suggestionsWrapper">
          مشتری های قبلی:
          {suggestions.map((suggestion) => (
            <div
              key={suggestion.nationalcode}
              className="suggestion"
              onClick={() => clickOnSuggestion(suggestion)}
            >
              {suggestion.nationalcode}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
